(function () {
    const TIMEZONE = 'Asia/Kolkata';

    /*
     * Store date/time helpers
     */

    function getTimeParts(date) {
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });

      const result = {};

      formatter.formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') {
          result[part.type] = Number(part.value);
        }
      });

      return result;
    }

    function getStoreNow() {
      return getTimeParts(new Date());
    }

    function createStoreDate(parts) {
      return new Date(
        Date.UTC(
          parts.year,
          parts.month - 1,
          parts.day,
          parts.hour,
          parts.minute,
          parts.second
        )
      );
    }

    function addDays(date, days) {
      const result = new Date(date);
      result.setUTCDate(result.getUTCDate() + Number(days));
      return result;
    }

    /*
     * Date formatting
     */

    function formatSingleDate(date) {
      const month = date.toLocaleDateString('en-IN', {
        month: 'short',
        timeZone: 'UTC'
      });

      const day = String(date.getUTCDate()).padStart(2, '0');

      return `${month} ${day}`;
    }

    function formatTimelineRange(start, end) {
      const startMonth = start.toLocaleDateString('en-IN', {
        month: 'short',
        timeZone: 'UTC'
      });

      const endMonth = end.toLocaleDateString('en-IN', {
        month: 'short',
        timeZone: 'UTC'
      });

      const startDay = String(start.getUTCDate()).padStart(2, '0');
      const endDay = String(end.getUTCDate()).padStart(2, '0');

      if (
        start.getUTCFullYear() === end.getUTCFullYear() &&
        start.getUTCMonth() === end.getUTCMonth() &&
        start.getUTCDate() === end.getUTCDate()
      ) {
        return `${startMonth} ${startDay}`;
      }

      if (
        start.getUTCMonth() === end.getUTCMonth() &&
        start.getUTCFullYear() === end.getUTCFullYear()
      ) {
        return `${startMonth} ${startDay} - ${endDay}`;
      }

      return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
    }

    function formatMessageDate(date) {
      const day = String(date.getUTCDate()).padStart(2, '0');
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const year = date.getUTCFullYear();

      return `${day}/${month}/${year}`;
    }

    function formatPropertyDate(date) {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }

    /*
     * Find the correct product form
     */

    function getProductForm(timeline) {
  // 1. If timeline is inside the product form
  const closestForm = timeline.closest(
    'form[data-type="add-to-cart-form"]'
  );

  if (closestForm) {
    return closestForm;
  }

  // 2. Try to use an explicitly assigned form ID
  const formId = timeline.dataset.productFormId;

  if (formId) {
    const assignedForm = document.getElementById(formId);

    if (assignedForm) {
      return assignedForm;
    }
  }

  // 3. Only use a global form if there is exactly ONE
  // product form on the page.
  const forms = document.querySelectorAll(
    'form[data-type="add-to-cart-form"]'
  );

  if (forms.length === 1) {
    return forms[0];
  }

  console.warn(
    '[Delivery] Could not determine the correct product form.',
    {
      timeline: timeline,
      formsFound: forms.length
    }
  );

  return null;
}

    /*
     * Read Express Delivery selection
     */

    function isExpressSelected(productForm) {
      const expressProperty =
        productForm?.querySelector('.express_property_selected');

      return expressProperty?.value === 'Yes';
    }

    /*
     * Cutoff calculation
     */

    function getCutoffInfo(nowParts, cutoffTime) {
      const cutoffParts = String(cutoffTime || '23:59').split(':');

      const cutoffHour = Number(cutoffParts[0] || 0);
      const cutoffMinute = Number(cutoffParts[1] || 0);

      const now = createStoreDate(nowParts);

      const cutoff = createStoreDate({
        year: nowParts.year,
        month: nowParts.month,
        day: nowParts.day,
        hour: cutoffHour,
        minute: cutoffMinute,
        second: 0
      });

      return {
        now: now,
        cutoff: cutoff,
        isBeforeCutoff: now < cutoff
      };
    }

    /*
     * Save delivery dates into Shopify line-item properties
     */

    function updateDeliveryProperties(
      timeline,
      productForm,
      deliveryStart,
      deliveryEnd,
      processingMin,
      processingMax,
      expressSelected
    ) {
      if (!productForm) {
        console.warn('[Delivery] Product form not found.');
        return;
      }

      const dateMinElement =
        productForm.querySelector('.pdt_property_date_min');

      const dateMaxElement =
        productForm.querySelector('.pdt_property_date_max');

      const typeElement =
        productForm.querySelector('.pdt_property_type');

      const processingMinElement =
        productForm.querySelector('.pdt_property_processing_min');

      const processingMaxElement =
        productForm.querySelector('.pdt_property_processing_max');

      const calculatedAtElement =
        productForm.querySelector('.pdt_property_calculated_at');

      let deliveryType = 'Standard';

      if (expressSelected) {
        deliveryType = 'Express';
      } else {
        const deliveryMin = Number(timeline.dataset.deliveryMin || 0);
        const deliveryMax = Number(timeline.dataset.deliveryMax || 0);

        if (deliveryMin === 0 && deliveryMax === 0) {
          const cutoffInfo = getCutoffInfo(
            getStoreNow(),
            timeline.dataset.cutoffTime || '23:59'
          );

          deliveryType = cutoffInfo.isBeforeCutoff
            ? 'Same Day'
            : 'Next Day';
        }
      }

      if (dateMinElement) {
        dateMinElement.value = formatPropertyDate(deliveryStart);
      }

      if (dateMaxElement) {
        dateMaxElement.value = formatPropertyDate(deliveryEnd);
      }

      if (typeElement) {
        typeElement.value = deliveryType;
      }

      if (processingMinElement) {
        processingMinElement.value = String(processingMin);
      }

      if (processingMaxElement) {
        processingMaxElement.value = String(processingMax);
      }

      if (calculatedAtElement) {
        calculatedAtElement.value = new Date().toISOString();
      }
    }

    /*
     * Live countdown
     */

    function updateCountdown(timeline) {
      const countdownElement =
        timeline.querySelector('.pdt_countdown');

      if (!countdownElement) {
        return;
      }

      const nowParts = getStoreNow();

      const cutoffInfo = getCutoffInfo(
        nowParts,
        timeline.dataset.cutoffTime || '23:59'
      );

      let targetCutoff = cutoffInfo.cutoff;

      if (!cutoffInfo.isBeforeCutoff) {
        targetCutoff = addDays(targetCutoff, 1);
      }

      const difference =
        targetCutoff.getTime() - cutoffInfo.now.getTime();

      const totalSeconds = Math.max(
        0,
        Math.floor(difference / 1000)
      );

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      countdownElement.textContent =
        `${hours} h ${String(minutes).padStart(2, '0')} min ${String(seconds).padStart(2, '0')} sec`;
    }

    /*
     * Update standard delivery message without duplicating
     * the existing "Order within" text node.
     */

    function setLeadingMessageText(messageElement, text) {
      if (!messageElement) {
        return;
      }

      const textNode = Array.from(messageElement.childNodes).find(
        function (node) {
          return (
            node.nodeType === Node.TEXT_NODE &&
            /Order within|Order now/.test(node.textContent)
          );
        }
      );

      if (textNode) {
        textNode.textContent = text;
      }
    }

   /*
 * Main timeline calculation
 */

function updateDeliveryTimeline() {
  document
    .querySelectorAll('.product_delivery_timeline')
    .forEach(function (timeline) {
      try {
        const processingMin =
          Number(timeline.dataset.processingMin || 0);

        const processingMax =
          Number(timeline.dataset.processingMax || 0);

        const deliveryMin =
          Number(timeline.dataset.deliveryMin || 0);

        const deliveryMax =
          Number(timeline.dataset.deliveryMax || 0);

        const productForm = getProductForm(timeline);

        const expressSelected =
          isExpressSelected(productForm);

        const cutoffTime =
          timeline.dataset.cutoffTime || '23:59';

        const nowParts = getStoreNow();

        const cutoffInfo = getCutoffInfo(
          nowParts,
          cutoffTime
        );

        /*
         * Purchased date
         *
         * Standard: preserve cutoff behavior.
         * Express: always use today's date.
         */

        let orderDate = createStoreDate(nowParts);

        if (
          !expressSelected &&
          !cutoffInfo.isBeforeCutoff
        ) {
          orderDate = addDays(orderDate, 1);
        }

        /*
         * Choose the active delivery ranges.
         *
         * Express: Processing 1–2 days, Delivery 2–4 days.
         * Standard: use product metafields/theme settings.
         */

        const expressProcessingMin = 0;
        const expressProcessingMax = 0;
        const expressDeliveryMin = 0;
        const expressDeliveryMax = 0;

        const activeProcessingMin = expressSelected
          ? expressProcessingMin
          : processingMin;

        const activeProcessingMax = expressSelected
          ? expressProcessingMax
          : processingMax;

        const activeDeliveryMin = expressSelected
          ? expressDeliveryMin
          : deliveryMin;

        const activeDeliveryMax = expressSelected
          ? expressDeliveryMax
          : deliveryMax;

        /*
         * Calculate timeline dates using the active ranges.
         */

        const processingStart = addDays(
          orderDate,
          activeProcessingMin
        );

        const processingEnd = addDays(
          orderDate,
          activeProcessingMax
        );

        const deliveryStart = addDays(
          orderDate,
          activeDeliveryMin
        );

        const deliveryEnd = addDays(
          orderDate,
          activeDeliveryMax
        );

        /*
         * Save line-item properties
         */

        updateDeliveryProperties(
          timeline,
          productForm,
          deliveryStart,
          deliveryEnd,
          activeProcessingMin,
          activeProcessingMax,
          expressSelected
        );

        /*
         * Purchased date
         */

        const purchasedElement =
          timeline.querySelector('.pdt_purchased_date');

        if (purchasedElement) {
          purchasedElement.textContent =
            formatSingleDate(orderDate);
        }

        /*
         * Processing date
         */

        const processingElement =
          timeline.querySelector('.pdt_processing_date');

        if (processingElement) {
          processingElement.textContent =
            formatTimelineRange(
              processingStart,
              processingEnd
            );
        }

        /*
         * Delivered date
         */

        const deliveryElement =
          timeline.querySelector('.pdt_delivery_range');

        if (deliveryElement) {
          deliveryElement.textContent =
            formatTimelineRange(
              deliveryStart,
              deliveryEnd
            );
        }

        /*
         * Switch Standard and Express messages
         */

        const standardMessage =
          timeline.querySelector('.pdt_standard_message');

        const expressMessage =
          timeline.querySelector('.pdt_express_message');

        const expressWindow =
          timeline.querySelector('.pdt_express_window');

        if (standardMessage) {
          standardMessage.hidden = expressSelected;
        }

        if (expressMessage) {
          expressMessage.hidden = !expressSelected;
        }

        if (expressWindow) {
          expressWindow.textContent =
            timeline.dataset.expressWindow ||
            'Within 4 hours of order confirmation';
        }

        /*
         * Update the Standard Delivery message only.
         * Keep its existing cutoff and countdown behavior.
         */

        if (!expressSelected) {
          const messageText =
            timeline.querySelector('.pdt_message_text');

          const suffixElement =
            timeline.querySelector('.pdt_message_suffix');

          if (messageText && suffixElement) {
            if (cutoffInfo.isBeforeCutoff) {
              setLeadingMessageText(
                messageText,
                'Order within '
              );

              const isSameDay =
                deliveryMin === 0 && deliveryMax === 0;

              if (isSameDay) {
                suffixElement.innerHTML =
                  'to get it <strong class="pdt_delivery_date">delivered today</strong>';
              } else {
                suffixElement.innerHTML =
                  'to get it delivered <strong class="pdt_delivery_date"></strong>';

                const dateElement =
                  suffixElement.querySelector(
                    '.pdt_delivery_date'
                  );

                if (dateElement) {
                  dateElement.textContent =
                    `${formatMessageDate(deliveryStart)} to ${formatMessageDate(deliveryEnd)}`;
                }
              }
            } else {
              setLeadingMessageText(
                messageText,
                'Order now '
              );

              const isTomorrow =
                deliveryMin === 0 && deliveryMax === 0;

              if (isTomorrow) {
                suffixElement.innerHTML =
                  'for <strong class="pdt_delivery_date">delivery tomorrow</strong>';
              } else {
                suffixElement.innerHTML =
                  'for delivery between <strong class="pdt_delivery_date"></strong>';

                const dateElement =
                  suffixElement.querySelector(
                    '.pdt_delivery_date'
                  );

                if (dateElement) {
                  dateElement.textContent =
                    `${formatMessageDate(deliveryStart)} and ${formatMessageDate(deliveryEnd)}`;
                }
              }
            }
          }
        }

        /*
         * Keep countdown current.
         */

        updateCountdown(timeline);

      } catch (error) {
        console.error(
          '[Delivery] Timeline update failed:',
          error
        );
      }
    });
}

    /*
     * Initialize
     */

    updateDeliveryTimeline();

    /*
     * Respond immediately to delivery option changes.
     */

    document.addEventListener('change', function (event) {
      if (
        event.target.matches('.express_property_selected')
      ) {
        updateDeliveryTimeline();
      }
    });

    /*
     * Support custom theme buttons that update the selection
     * without firing a change event on the hidden field.
     */

    document.addEventListener('click', function (event) {
      if (
        event.target.closest(
          'button, label, [role="button"]'
        )
      ) {
        setTimeout(function () {
          updateDeliveryTimeline();
        }, 100);
      }
    });

    /*
     * Refresh countdown every second.
     */

    setInterval(function () {
      document
        .querySelectorAll('.product_delivery_timeline')
        .forEach(function (timeline) {
          updateCountdown(timeline);
        });
    }, 1000);

    /*
     * Recalculate dates periodically for cutoff changes.
     */

    setInterval(function () {
      updateDeliveryTimeline();
    }, 60000);

  })();